import { useAtom } from '@reatom/npm-react'
import { Trans, useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { premiumFontCss } from '@blade/ui-theme'
import { userPremiumTabAtom } from '@root/features/premium'
import { UnderlineTabs } from '@root/shared/ui-kit'

import type { UserPremiumTab } from '@root/features/premium'

export const PremiumPageContentTabs: React.FC = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(userPremiumTabAtom)

  return (
    <UnderlineTabs
      value={tab}
      onChange={setTab}
      css={css`
        padding-inline: 14px;
        grid-template-columns: auto auto auto 1fr;
      `}
    >
      <UnderlineTabs.Tab value={'active' satisfies UserPremiumTab}>
        <Uppercase>
          <Trans
            i18nKey="premium.purchased.tab.active"
            components={[<Tab key={0} />]}
          />
        </Uppercase>
      </UnderlineTabs.Tab>
      <UnderlineTabs.Tab value={'past' satisfies UserPremiumTab}>
        {t('premium.purchased.tab.inactive')}
      </UnderlineTabs.Tab>
      <UnderlineTabs.Tab value={'purchase-history' satisfies UserPremiumTab}>
        {t('premium.purchased.tab.purchase-history')}
      </UnderlineTabs.Tab>
    </UnderlineTabs>
  )
}

const Uppercase = styled.span`
  margin-top: 6px;
`

const Tab = styled.span`
  ${premiumFontCss}
`
